const collection = {
    addComma() {
        document.querySelectorAll(".formatted-number").forEach(function(el) {
            const rawNumber = parseInt(el.getAttribute("data-count"), 10);
            if (!isNaN(rawNumber)) {
                el.textContent = rawNumber.toLocaleString();
            }
        });
    },
    deliveryWindow() {
        const daysBegin = Number(document.getElementById("deliveryWindowDaysBegin").value);
        const daysEnd = Number(document.getElementById("deliveryWindowDaysEnd").value);
        const days = this.getBusinessDays(daysEnd);
        const startDate = days[daysBegin - 1];
        const endDate = days[daysEnd - 1];
        const fmtMachine = new Intl.DateTimeFormat("en-US", {
            month: "numeric",
            day: "numeric",
            year: "2-digit"
        });
        const startMonth = startDate.toLocaleString("en-US", { month: "numeric" });
        const endMonth = endDate.toLocaleString("en-US", { month: "numeric" });
        const startDay = startDate.getDate();
        const endDay = endDate.getDate();
        const formatted = `${startMonth}/${startDay} – ${endMonth}/${endDay}`;
        document.getElementById("pdt-upsellerDeliveryDate").innerText = formatted;
    },
    getBusinessDays(count) {
        const start = new Date();
        const holidays = JSON.parse(document.getElementById("holidays").value);
        const days = [];
        let cursor = new Date(start);
        while (days.length < count) {
            cursor.setDate(cursor.getDate() + 1);
            const formattedDate = cursor.toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric"
            });
            const day = cursor.getDay();
            if (
                day !== 0 &&
                day !== 6 &&
                !holidays.includes(formattedDate)
            ) {
                days.push(new Date(cursor));
            }
        }
        return days;
    },
    setHandlers() {
        $("#slt-sortBy").on("change", function () {
            location.search = new URLSearchParams(`sort_by=${this.value}`).toString();
        });
    },
    setSortLabels() {
        const sort_by = document.getElementById("slt-sortBy");
        if (!sort_by) {
            return;
        }
        const sort_labels = {
            "manual": "Featured",
            "most-relevant": "Relevant",
            "best-selling": "Top Sellers",
            "title-ascending": "A-Z",
            "title-descending": "Z-A",
            "price-ascending": "Price ↑",
            "price-descending": "Price ↓",
            "created-ascending": "Date ↑",
            "created-descending": "Date ↓",
        };
        const original_labels = new Map(
            Array.from(sort_by.options, option => [option.value, option.textContent.trim()])
        );
        const mobile_query = window.matchMedia("(max-width: 767.98px)");
        function updateSortLabels(event) {
            Array.from(sort_by.options).forEach(option => {
                option.textContent = event.matches
                    ? sort_labels[option.value] ?? original_labels.get(option.value)
                    : original_labels.get(option.value);
            });
        }
        mobile_query.addEventListener("change", updateSortLabels);
        updateSortLabels(mobile_query);
    },
    start() {
        this.setHandlers();
        this.setSortLabels();
        this.deliveryWindow();
        this.addComma();
    },
};
$(function () {
    collection.start();
});